import { TRACKING } from "./config";

const injectScript = (src, onload) => {
  const s = document.createElement("script");
  s.async = true;
  s.src = src;
  if (onload) s.onload = onload;
  document.head.appendChild(s);
};

// Google Ads tag (AW-17777851742) is loaded directly in public/index.html on every page.
// This only adds GA4 / Meta Pixel when their IDs are configured, reusing the existing gtag.
export const initTracking = () => {
  if (TRACKING.ga4) {
    if (!window.gtag) {
      window.dataLayer = window.dataLayer || [];
      window.gtag = function () { window.dataLayer.push(arguments); };
      window.gtag("js", new Date());
      injectScript(`https://www.googletagmanager.com/gtag/js?id=${TRACKING.ga4}`);
    }
    window.gtag("config", TRACKING.ga4);
  }
  if (TRACKING.metaPixel) {
    if (!window.fbq) {
      const n = (window.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); });
      n.push = n; n.loaded = true; n.version = "2.0"; n.queue = [];
      injectScript("https://connect.facebook.net/en_US/fbevents.js");
    }
    window.fbq("init", TRACKING.metaPixel);
    window.fbq("track", "PageView");
  }
};

export const trackPageView = (path) => {
  if (window.gtag && TRACKING.ga4) window.gtag("event", "page_view", { page_path: path });
  if (window.fbq && TRACKING.metaPixel) window.fbq("track", "PageView");
};

// Event names: order_click, phone_click, directions_click, catering_form_submit, email_signup, sms_signup, text_click, app_download_click
export const trackEvent = (name, params = {}) => {
  if (window.gtag) window.gtag("event", name, params);
  if (window.fbq) window.fbq("trackCustom", name, params);
  if (process.env.NODE_ENV === "development") console.debug("[track]", name, params);
};

export const trackConversion = (name, params = {}) => {
  trackEvent(name, params);
  if (window.gtag && TRACKING.googleAdsId && TRACKING.googleAdsLabel) {
    window.gtag("event", "conversion", { send_to: `${TRACKING.googleAdsId}/${TRACKING.googleAdsLabel}` });
  }
  if (window.fbq && TRACKING.metaPixel) window.fbq("track", "Lead", params);
};
